/**
 * Identifiants de la connexion Miles Republic.
 *
 * MR-3171 — la table `database_connections` a été supprimée : elle stockait
 * l'URL de connexion à la production en clair, et `GET /api/databases`, route
 * publique et non authentifiée, la renvoyait. La connexion vient désormais de
 * la variable d'environnement `MILES_REPUBLIC_DATABASE_URL`, et ces
 * identifiants ne désignent plus une ligne de base mais une constante
 * partagée par l'API, les agents et le framework.
 *
 * Ils vivent dans `@data-agents/types` — le seul paquet sans dépendance —
 * pour rester accessibles à `packages/database` sans rouvrir le cycle avec
 * `agent-framework`.
 *
 * @since 2026-09-09 - MR-3171
 */
/** Identifiant canonique. Toute nouvelle configuration d'agent l'utilise. */
export const MILES_REPUBLIC_CONNECTION_ID = 'miles-republic';
/**
 * CUID historique de la ligne `Miles Republic Production`, relevé en
 * production le 09/09/2026.
 *
 * Dix agents le portent encore dans leur `config` JSON (`sourceDatabase` ou
 * `milesRepublicDatabase`). Il reste accepté pour que la bascule ne dépende
 * pas d'une migration de données simultanée.
 *
 * ⚠️ À supprimer après passage de `scripts/migrate-agent-source-database.ts`.
 */
export const LEGACY_MILES_REPUBLIC_CONNECTION_ID = 'cmi0gruke000089z4lv2758nk';
/** Nom de la variable d'environnement portant l'URL de connexion. */
export const MILES_REPUBLIC_ENV_VAR = 'MILES_REPUBLIC_DATABASE_URL';
/** Identifiants acceptés pour désigner la connexion Miles Republic. */
export const MILES_REPUBLIC_CONNECTION_IDS = [
    MILES_REPUBLIC_CONNECTION_ID,
    LEGACY_MILES_REPUBLIC_CONNECTION_ID
];
/** Vrai si l'identifiant désigne la connexion Miles Republic. */
export function isMilesRepublicConnectionId(id) {
    return !!id && MILES_REPUBLIC_CONNECTION_IDS.includes(id);
}
//# sourceMappingURL=miles-republic-connection.js.map